import React from "react";

import style from "./homeworkList.module.scss";
import { Tabs, Empty } from "antd";
import HomeworkBlock from "./component/homeworkBlock";
import { getHomeworkList, HomeworkListItem } from "API";
import HomeworkTable from "./component/homeworkTable";
import { useHistory } from "react-router-dom";
import LoadingWrapper from "components/LoadingWrapper";
import useRequest from "Utils/useRequest";
import { Tabs as MTabs } from "antd-mobile";
import HomeworkList from "./component/homeworkList";
import PlatformWrap from "components/PlatformWrap";

export type IHandleHomework = (
    courseNo: string,
    courseSeq: string,
    weekNo: string,
    dayOfWeek: string,
    section: string,
    continunity: string,
    homeworkStatus: string,
    paperId: string,
    weekTimeId: string
) => void;

interface Props {
    homeworkList: HomeworkListItem[];
    handleHomework: IHandleHomework;
}

const PageHomeworkList = () => {
    const [homeworkList, { loading }] = useRequest(() => getHomeworkList());
    const history = useHistory();

    const handleHomework = (
        courseNo: string,
        courseSeq: string,
        weekNo: string,
        dayOfWeek: string,
        section: string,
        continunity: string,
        homeworkStatus: string,
        paperId: string,
        weekTimeId: string
    ) => {
        if (homeworkStatus === "3") {
            homeworkStatus = "1";
        }
        if (homeworkStatus === "4") {
            homeworkStatus = "2";
        }
        let base64 = window.btoa(
            `${courseNo}-${courseSeq}-${weekNo}-${dayOfWeek}-${section}-${continunity}-${homeworkStatus}-${paperId}-${weekTimeId}`
        );
        history.push(`/homework/${base64}`);
    };

    return (
        <LoadingWrapper isEmpty={!homeworkList} loading={loading}>
            {() => (
                <PlatformWrap
                    mobile={
                        <Mobile
                            homeworkList={homeworkList!}
                            handleHomework={handleHomework}
                        />
                    }
                    pc={
                        <PC
                            homeworkList={homeworkList!}
                            handleHomework={handleHomework}
                        />
                    }
                />
            )}
        </LoadingWrapper>
    );
};

const Mobile = ({ homeworkList, handleHomework }: Props) => {
    const tabs = [
        { title: "未完成" },
        { title: "待批改" },
        { title: "已批改" },
        { title: "已过期" }
    ];

    return (
        <div className={style.main}>
            <MTabs tabs={tabs} swipeable={false}>
                <div className={style.mTab}>
                    <HomeworkList
                        btnText="做作业"
                        status="1"
                        list={homeworkList?.filter(
                            homework => parseInt(homework.homeworkStatus) === 1
                        )}
                        handleHomework={handleHomework}
                    />
                </div>
                <div className={style.mTab}>
                    <HomeworkList
                        btnText="修改"
                        status="3"
                        list={homeworkList?.filter(
                            homework => parseInt(homework.homeworkStatus) === 3
                        )}
                        handleHomework={handleHomework}
                    />
                </div>
                <div className={style.mTab}>
                    <HomeworkList
                        btnText="查看"
                        status="2"
                        list={homeworkList?.filter(
                            homework => parseInt(homework.homeworkStatus) === 2
                        )}
                        handleHomework={handleHomework}
                    />
                </div>
                <div className={style.mTab}>
                    <HomeworkList
                        btnText="查看"
                        status="4"
                        list={homeworkList?.filter(
                            homework => parseInt(homework.homeworkStatus) === 4
                        )}
                        handleHomework={handleHomework}
                    />
                </div>
            </MTabs>
        </div>
    );
};

const PC = ({ homeworkList, handleHomework }: Props) => {
    return (
        <div className={style.main}>
            <div className={style.block}>
                <h1 className={style.subTitle}>待完成作业</h1>
                <div className={style.homeworkBlockWrap}>
                    {homeworkList!
                        ?.filter(
                            homework => parseInt(homework?.homeworkStatus) === 1
                        )
                        ?.map((item, index) => (
                            <div
                                key={`${item?.courseNo}${item?.week}${item?.weekTime}${item?.section}`}
                                className={style.homeworkBlock}>
                                <HomeworkBlock
                                    handleHomework={handleHomework}
                                    courseInfo={item}
                                />
                            </div>
                        ))}
                    {homeworkList?.filter(
                        homework => parseInt(homework?.homeworkStatus) === 1
                    )?.length === 0 && <Empty description="暂无数据" />}
                </div>
            </div>
            <div className={style.block}>
                <h1 className={style.subTitle}>作业列表</h1>
                <Tabs defaultActiveKey="3">
                    <Tabs.TabPane tab="待批改" key="3">
                        <HomeworkTable
                            handleHomework={handleHomework}
                            homeworkStatus="3"
                            list={homeworkList?.filter(
                                homework =>
                                    parseInt(homework.homeworkStatus) === 3
                            )}
                        />
                    </Tabs.TabPane>
                    <Tabs.TabPane tab="已批改" key="2">
                        <HomeworkTable
                            handleHomework={handleHomework}
                            homeworkStatus="2"
                            list={homeworkList?.filter(
                                homework =>
                                    parseInt(homework.homeworkStatus) === 2
                            )}
                        />
                    </Tabs.TabPane>
                    <Tabs.TabPane tab="已过期" key="4">
                        <HomeworkTable
                            handleHomework={handleHomework}
                            homeworkStatus="4"
                            list={homeworkList?.filter(
                                homework =>
                                    parseInt(homework.homeworkStatus) === 4
                            )}
                        />
                    </Tabs.TabPane>
                </Tabs>
            </div>
        </div>
    );
};

export default PageHomeworkList;
